import api from './client';

export interface Pricing {
  currency: string;
  /** Fee charged when an application is submitted, by the listing's type. */
  applicationFees: { rental: number; sale: number };
}

interface PricingResponse {
  status: number;
  message?: string;
  pricing: Pricing;
}

/** GET /api/pricing */
export const getPricing = async (): Promise<Pricing> => {
  const res = await api.get<PricingResponse>('/pricing');
  return res.data.pricing;
};

/** PUT /api/pricing (admin) — send only the fees that change. */
export const updatePricing = async (
  applicationFees: Partial<Pricing['applicationFees']>
): Promise<Pricing> => {
  const res = await api.put<PricingResponse>('/pricing', { applicationFees });
  return res.data.pricing;
};
